export default __webpack_public_path__ + "static/media/airbnb.9a012973.svg";